export const hub = {
    headerTitle: 'Hub',
    route: 'hub',
    pageTitle: 'paed.ML Hub',
    related: [
      { route: 'jobverwaltung/jobs', menuTitle: 'Jobs ansehen' },
      { route: 'benutzerverwaltung', menuTitle: 'Benutzerverwaltung' },
      { route: 'mdm/grundeinstellungen', menuTitle: 'MDM verwalten' },
    ],
    cards: [
      
      {
        route: 'settings',
        icon: 'fas-cogs',
        endpoint: '/api/hub/hostparams',
        preHooks: {
          list: 'hub_list_preHook'
        },
        tag: 'paedml-card-hub',
        category: 'paed.ML Hub',
        menuTitle: 'Einstellungen verwalten',
        pageTitle: 'paed.ML - Hub: Einstellungen',
        name: 'hub',
        contentTitle: 'Einstellungen',
        prefix: 'settings',
        suffix: undefined,
        table: {
          columns: [
            { title: 'Name', name: 'name', col: 0 },
            { title: 'Wert', name: 'value', col: 1 }
          ],
          data: {
            url: '',
            dataSrc: ''
          },
          custom: {
            pageLength: 10,
          }
        }
      },

      {
        route: 'parameter',
        icon: 'internet-2',
        endpoint: '/api/hub',
        preHooks: {
        },
        tag: 'paedml-card-hubparameter',
        category: 'paed.ML Hub',
        menuTitle: 'Parameter verwalten',
        pageTitle: 'paed.ML - Hub: Parameter',
        name: 'parameter',
        contentTitle: 'Parameter',
        prefix: 'parameter',
        suffix: undefined,
        table: {
          columns: [
            { title: 'Id', name: 'id', col: 0, visible: false, searchable: false, printable: false, exportable: false },
            { title: 'Name', name: 'name', col: 1 },
            { title: 'FQDN', name: 'fqdnAddress', col: 2, visible: true, searchable: false, printable: true, exportable: true},
            { title: 'ProxyPass-Parameter', name: 'parameter', col: 3, visible: true, searchable: false, printable: true, exportable: true},
            { title: 'Beschreibung', name: 'description', col: 4, visible: true, searchable: false, printable: true, exportable: true },
            { title: 'isDeletable', name: 'isDeletable', col: 5, visible: false, searchable: false, printable: false, exportable: false},
          ],
          data: {
            url: '',
            dataSrc: ''
          },
          custom: {
            pageLength: 10,
          }
        }
      }

    ]
  }
